<template>
  <!-- THE APP'S ONE CREATE DOOR — one verb, no panel (design 165). It used to
       open a panel naming three intents; the form asks the deal's state itself
       now, as four cards under the type, so the door has nothing left to ask.
       ⭐ SOLID, in the brand's one hue: this is the app's standard create
       affordance, alone at the head of the content column — the only coloured
       thing in the header, which is exactly the weight the one create verb
       should carry. -->
  <Button class="h-9 gap-1.5 font-semibold" data-testid="intake-new-job" @click="launch()">
    <Plus class="h-4 w-4" />
    {{ t('records.newJob') }}
  </Button>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { Plus } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import { useIntakeDoors } from '@/composables/useIntakeDoors'

const { t } = useI18n()
const { launch } = useIntakeDoors()
</script>
